import PlusBadge from 'components/shared/PlusBadge';
import { Button, Dropdown } from 'components/ui';
import React, { useContext } from 'react'
import { Trans } from 'react-i18next';
import { BsStars } from 'react-icons/bs';
import useImageGenerationQuantity from 'utils/hooks/useImageGenerationQuantity';
import AIPriceBadge from 'components/shared/AIPriceBadge';
import { AIContext } from 'contexts/AIContext';

export default function AIImageGenerateButton({
  isLoading,
  query,
  generateImages,
  model
}) {
  const { aiModels } = useContext(AIContext);
  const maxSelection = 5;
  const maxAllowedSelection = useImageGenerationQuantity();
  
  // Get current image model pricing
  const imageModel = aiModels.find(m => m.model === model && m.type === 'image');
  const imagePrice = imageModel?.price || 0;

  return (
    <Dropdown
      placement="top-end"
      disabled={isLoading || !query?.trim()}
      parentClassName="w-full"
      renderTitle={
        <Button 
          loading={isLoading}
          disabled={isLoading || !query?.trim()}
          variant="ai" 
          size="md" 
          className="w-full flex gap-2 items-center !text-sm flex-1 justify-center !bg-gradient-to-r !from-pink-500 !to-orange-600 hover:!from-pink-600 hover:!to-orange-700 !border-0 !text-white !font-medium !shadow-lg !shadow-pink-500/25 hover:!shadow-pink-500/40 !transition-all !duration-300 disabled:!opacity-50 disabled:!cursor-not-allowed disabled:!shadow-none"
          icon={<BsStars />}
        >
          <span className="flex items-center gap-2">
            <Trans i18nKey={`aiImage.generate`}>Generate</Trans>
            {!isLoading && query?.trim() && (
              <AIPriceBadge
                price={imagePrice}
                quantity={1}
                priceType="generation"
                size="sm"
                variant="pink"
                className="!bg-white/20 !text-white !border-white/30"
              />
            )}
          </span>
        </Button>
      }
    >
      {[...Array(maxSelection).keys()].map((key) => (
        key+1 <= maxAllowedSelection 
          ? <Dropdown.Item 
            onClick={() => generateImages(key+1)} 
            className="py-2 flex items-center justify-between gap-3"
          >
            <span>Generate {key+1} image{key != 0 && `s`}</span>
            <AIPriceBadge
              price={imagePrice}
              quantity={key+1}
              priceType="generation"
              size="sm"
              variant="pink"
              animate={false}
            />
          </Dropdown.Item>
          : <Dropdown.Item 
            onClick={(e) => e?.stopPropagation()} 
            className="py-2 flex items-center justify-between gap-6"
          >
            <span className='opacity-30'>Generate {key+1} image{key != 0 && `s`}</span>
            <PlusBadge 
              wrapperClassName={`shrink-0 -mr-0.5`}
              className={`text-2xl`} 
              feature={`Multiple AI Image Generation`}
              placement="right"
            />
          </Dropdown.Item>
      ))}
    </Dropdown>
  );
}
